import { DEFAULT_CREATED_AT_FIELD, DEFAULT_ID_FIELD, DEFAULT_LEGACY_DATA_FIELD, DEFAULT_SCHEMA_VERSION_FIELD } from "@/lib/collections/helpers/sharedFieldConstants";
import { generateIdResolverSingle } from "../../utils/schemaUtils";
import { TupleSet, UnionOf } from "../../utils/typeGuardUtils";

export const DIGEST_STATUSES = new TupleSet(["yes", "maybe", "no"] as const);
export type InDigestStatus = UnionOf<typeof DIGEST_STATUSES>;

const schema = {
  _id: DEFAULT_ID_FIELD,
  schemaVersion: DEFAULT_SCHEMA_VERSION_FIELD,
  createdAt: DEFAULT_CREATED_AT_FIELD,
  legacyData: DEFAULT_LEGACY_DATA_FIELD,
  digestId: {
    database: {
      type: "VARCHAR(27)",
      foreignKey: "Digests",
      nullable: false,
    },
    graphql: {
      outputType: "String!",
      canRead: ["guests"],
      canUpdate: ["admins"],
      canCreate: ["admins"],
    },
  },
  digest: {
    graphql: {
      outputType: "Digest!",
      canRead: ["guests"],
      resolver: generateIdResolverSingle({ foreignCollectionName: "Digests", fieldName: "digestId" }),
    },
  },
  postId: {
    database: {
      type: "VARCHAR(27)",
      foreignKey: "Posts",
      nullable: false,
    },
    graphql: {
      outputType: "String!",
      canRead: ["guests"],
      canUpdate: ["admins"],
      canCreate: ["admins"],
    },
  },
  post: {
    graphql: {
      outputType: "Post",
      canRead: ["guests"],
      resolver: generateIdResolverSingle({ foreignCollectionName: "Posts", fieldName: "postId" }),
    },
  },
  emailDigestStatus: {
    database: {
      type: "TEXT",
      nullable: true,
    },
    graphql: {
      outputType: "String",
      canRead: ["guests"],
      canUpdate: ["admins"],
      canCreate: ["admins"],
      validation: {
        optional: true,
      },
    },
  },
  onsiteDigestStatus: {
    database: {
      type: "TEXT",
      nullable: true,
    },
    graphql: {
      outputType: "String",
      canRead: ["guests"],
      canUpdate: ["admins"],
      canCreate: ["admins"],
      validation: {
        optional: true,
      },
    },
  },
  onsiteDigestAt: {
    database: {
      type: "TIMESTAMPTZ",
      nullable: true,
    },
    graphql: {
      outputType: "Date",
      inputType: "Date",
      canRead: ["admins"],
      canUpdate: ["admins"],
      canCreate: ["admins"],
     onCreate: ({ document }) => {
        if (document.onsiteDigestStatus === "yes") {
          return new Date();
        }
        return null;
      },
      onUpdate: ({ newDocument, oldDocument }) => {
        if (newDocument.onsiteDigestStatus === "yes") {
          return oldDocument.onsiteDigestAt ?? new Date();
        }
        return null;
      },
      validation: {
        optional: true,
      },
    },
  },
} satisfies Record<string, CollectionFieldSpecification<"DigestPosts">>;

export default schema;
